import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { WhatsAppFloat, MobileStickyCta } from "@/components/WhatsAppFloat";
import Hero from "@/components/sections/Hero";
import Showroom from "@/components/sections/Showroom";
import WhyWebsite from "@/components/sections/WhyWebsite";
import WhoNeeds from "@/components/sections/WhoNeeds";
import Services from "@/components/sections/Services";
import Pricing from "@/components/sections/Pricing";
import HowItWorks from "@/components/sections/HowItWorks";
import BeforeAfter from "@/components/sections/BeforeAfter";
import Journey from "@/components/sections/Journey";
import WebsiteBenefits from "@/components/sections/WebsiteBenefits";
import Faq from "@/components/sections/Faq";
import About from "@/components/sections/About";
import Contact from "@/components/sections/Contact";
import FinalCta from "@/components/sections/FinalCta";

const Home = () => (
  <div className="pb-20 sm:pb-0" data-testid="home-page">
    <Navbar />
    <main>
      <Hero />
      <Showroom />
      <WhyWebsite />
      <WhoNeeds />
      <Services />
      <Pricing />
      <HowItWorks />
      <BeforeAfter />
      <Journey />
      <WebsiteBenefits />
      <Faq />
      <About />
      <Contact />
      <FinalCta />
    </main>
    <Footer />
    <WhatsAppFloat />
    <MobileStickyCta />
  </div>
);

export default Home;
